
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const stockService = {
  stockAdjustmentDetails,
  stockAdjustmentList,
  stockAdjustmentListByDate,
  stockAdjustmentSearch,
  submitStockAdjustment,
  stockAdjustmentAction,
  stockViewList,
  stockViewDetails,
  stockViewDetailsHistory

};

//========= STOCK View =============== 
async function  stockViewList() {
    return apiClient.get(`/stock/stock-view-list`, authHeader());
}

async function  stockViewDetails(salesOrderId) {
    return apiClient.get(`/stock/stock-view-details/${salesOrderId}`, authHeader());
}

async function  stockViewDetailsHistory(salesOrderId, data = null) {
    return apiClient.post(`/stock/stock-view-details-history/${salesOrderId}`, data, authHeader());
}

//========= STOCK View  END



//========= STOCK ADJUSTMENT
async function  stockAdjustmentList() {
    return apiClient.get(`/stock/stock-adjustment-list`, authHeader());
}



async function  stockAdjustmentListByDate(body) {
    return apiClient.put(`/stock/stock-adjustment-by-date`, body, authHeader());
}


async function  stockAdjustmentSearch(searchText) {
    return apiClient.get(`/stock/stock-adjustment-search?search=${searchText}`, authHeader());
}

async function  stockAdjustmentDetails(salesOrderId) {
    return apiClient.get(`/stock/stock-adjustment-details/${salesOrderId}`, authHeader());
}


async function  submitStockAdjustment(formData) {
    return apiClient.post(`/stock/submit-stock-adjustment`,formData, authHeader());
}


async function  stockAdjustmentAction(formData) {
    return apiClient.put(`/stock/stock-adjustment-action`,formData, authHeader());
}





// ============= STOCK ADJUSTMENT END============



















